import { initProductBuyTile } from '../../../snippets/product-buy-tile-control/product-buy-tile-control';

export const initPlugInControlsSectionTiles = () => {
  const plugInControlProductEls = document.querySelectorAll(
    '[data-list-collections-plug-in-controls-product]'
  );

  plugInControlProductEls.forEach((productEl) => {
    const productId = productEl.getAttribute(
      'data-list-collections-plug-in-controls-product'
    );

    if (productId) {
      initProductBuyTile(productId);
    }
  });
};
